import { CancelActionContext } from "./CancelActionContext";
import usePrepareCancel from "./usePrepareCancel";
import useCancel from "./useCancel";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function useCancelAction(index: any): any {
  const prepareCancel = usePrepareCancel();
  const prepareCancelFunction = (id: any) => prepareCancel(id);

  const onSuccessCancel = () => {
    setShowModal(false);
    index();
  };
  
  const Cancel = useCancel();

  const CancelFunction = () => Cancel(onSuccessCancel);

  const contextInstance = useContext(CancelActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "cancel_super_order",
    onSubmit: () => CancelFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <p>{t('are_you_sure_you_want_to_cancel_this_super_order?')}</p>
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareCancelFunction,
    actionTemplate,
  };
}

export default useCancelAction;
